export default __webpack_public_path__ + "static/media/Jazz.21c55b07.mp3";